import { Get, Post, Delete } from "."

export const fetch_backups = (perPage = 25, page = 1) =>
  Get(`database-backups?per_page=${perPage}&page=${page}`, false)

export const fetch_backup_tables = () =>
  Get("database-backups/tables")

export const fetch_queue_health = () =>
  Get("database-backups/queue-health")

export const create_backup = (data) => Post("database-backups")(data)

export const send_backup_link = async (id) => {
  const handler = Post(`database-backups/${id}/send-link`)
  return handler({})
}

export const cancel_backup = async (id) => {
  const handler = Post(`database-backups/${id}/cancel`)
  return handler({})
}

export const delete_backup = (id) => Delete(`database-backups/${id}`)
